// React binding for the device-local call log (storage/kvStores.ts, the
// brain's KV-backed KvCallLog — docs/09 §10). The shell appends entries when
// the engine publishes an ended call; screens rendering through this hook
// (Main Recents, contact detail history) update live.

import { useSyncExternalStore } from 'react';
import type { StoredCallLogEntry } from '../../storage/kvStores.js';
import { getCallLog, subscribeCallLog } from '../../storage/kvStores.js';

export function useCallLog(): readonly StoredCallLogEntry[] {
  return useSyncExternalStore(subscribeCallLog, getCallLog, getCallLog);
}
